import { LoadingService } from '../../../shared/services/loading/loading.service.ts';

export const configurationTabLoadingService = new LoadingService();
